import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setMenuLateral, openModalBottom } from '../../actions/ui';
import { startLoadSuscripcionActiva, setSuscripcionActiva } from '../../actions/suscripciones';
import { useSubscriptions } from '../../hooks/useSubscriptions';
import { ArrowDownSmallIcon } from '../../assets/svg/iconos';

import EstadoSuscripcion from './components/EstadoSuscripcion';
import InformacionPago from './components/InformacionPago';
import HistorialTransacciones from './components/HistorialTransacciones';
import { SuscripcionRowItem } from './components/SuscripcionRowItem';

export const Suscripciones = () => {
  const dispatch = useDispatch();
  
  const { colores, miniLateral } = useSelector(state => state.ui);
  const { empresa, role } = useSelector(state => state.auth);
  const { actualSuscripcion: actualSuscripcionAuth } = useSelector(state => state.auth);
  const { suscripcion } = useSelector(state => state.suscripciones);
  const actualSuscripcion = suscripcion?._id ? suscripcion : actualSuscripcionAuth;
  
  const isSuperAdmin = role === 'SUPERADMIN_ROLE' || role === 'ADMIN_ROLE';
  const isSuperAdminPanel = isSuperAdmin && window.location.hostname === process.env.REACT_APP_ADMIN_URL;
  const { loading: loadingSubscriptions, suscripciones } = useSubscriptions();

  const [isLoading, setIsLoading] = useState(false);
  const [timeoutId, setTimeoutId] = useState(null);
  const [suscripcionesList, setSuscripcionesList] = useState([]);
  const [orderBy, setOrderBy] = useState('creacion');
  const [asc, setAsc] = useState(false);
  const [ascEstado, setAscEstado] = useState(true);
  const [ascCreacion, setAscCreacion] = useState(false);
  const [pagNumber, setPagNumber] = useState(1);
  const LIMITE_SUSCRIPCIONES = 10;

  useEffect(() => {
    dispatch(setMenuLateral('suscripcion'));
  }, [dispatch]);

  useEffect(() => {
    if (empresa?._id && (!isSuperAdmin || !isSuperAdminPanel)) {
      dispatch(startLoadSuscripcionActiva(empresa._id));
    }
  }, [dispatch, empresa, isSuperAdmin, isSuperAdminPanel]);

  useEffect(() => {
    if (!isSuperAdminPanel) {
      return;
    }
    
    if (suscripciones) {
      const sorted = [...suscripciones].sort((a, b) => {
        let aValue, bValue;
        
        if (orderBy === 'estado') {
          aValue = (a.estado || '').toLowerCase();
          bValue = (b.estado || '').toLowerCase();
        } else if (orderBy === 'creacion') {
          aValue = a.createdAt ? new Date(a.createdAt).getTime() : (a.fechaCreacion ? new Date(a.fechaCreacion).getTime() : 0);
          bValue = b.createdAt ? new Date(b.createdAt).getTime() : (b.fechaCreacion ? new Date(b.fechaCreacion).getTime() : 0);
        } else {
          return 0;
        }
        
        if (aValue < bValue) return asc ? -1 : 1;
        if (aValue > bValue) return asc ? 1 : -1;
        return 0;
      });
      
      setSuscripcionesList(sorted);
      setPagNumber(1);
    }
  }, [isSuperAdminPanel, suscripciones, orderBy, asc, ascEstado, ascCreacion]);

  const changeOrderItem = (item) => {
    let newAsc;
    
    if (item === 'estado') {
      newAsc = orderBy === 'estado' ? !ascEstado : true;
      setAscEstado(newAsc);
      if (orderBy !== 'estado') {
        setAscCreacion(true);
      }
    } else if (item === 'creacion') {
      newAsc = orderBy === 'creacion' ? !ascCreacion : false;
      setAscCreacion(newAsc);
      if (orderBy !== 'creacion') {
        setAscEstado(true);
      }
    }
    
    setOrderBy(item);
    setAsc(newAsc);
    setPagNumber(1);
  };

  useEffect(() => {
    if (!isSuperAdminPanel) {
      if (!actualSuscripcion) {
        setIsLoading(true);
        const id = setTimeout(() => {
          setIsLoading(false);
          dispatch(openModalBottom({ text: ['Tiempo de carga excedido'], timeOut: 4 }));
        }, 3000);
        setTimeoutId(id);
      } else {
        setIsLoading(false);
        if (timeoutId) {
          clearTimeout(timeoutId);
          setTimeoutId(null);
        }
      }
    }
  }, [actualSuscripcion, dispatch, isSuperAdminPanel, timeoutId]);

  const handleUpdateSuscripcion = (suscripcionActualizada) => {
    if (isSuperAdminPanel) {
      setSuscripcionesList(prev => 
        prev.map(s => {
          if (s._id === suscripcionActualizada._id) {
            const empresaPreservada = typeof suscripcionActualizada.empresa === 'string' && typeof s.empresa === 'object' 
              ? s.empresa 
              : suscripcionActualizada.empresa;
            
            return { 
              ...s, 
              ...suscripcionActualizada,
              empresa: empresaPreservada
            };
          }
          return s;
        })
      );
    } else {
      dispatch(setSuscripcionActiva(suscripcionActualizada));
    }
  };

  const paginacion = (valor) => {
    if (valor === -1000) {
      setPagNumber(1);
    } else if (valor === 1) {
      setPagNumber(pagNumber + 1);
    } else if (valor === 1000000000) {
      setPagNumber(Math.ceil(suscripcionesList.length / LIMITE_SUSCRIPCIONES));
    } else {
      if (pagNumber <= 1) return;
      setPagNumber(pagNumber - 1);
    }
  };

  const startIndex = (pagNumber - 1) * LIMITE_SUSCRIPCIONES;
  const endIndex = startIndex + LIMITE_SUSCRIPCIONES;
  const suscripcionesPaginadas = suscripcionesList.slice(startIndex, endIndex);


  if (!isSuperAdminPanel) {
    return (
      <div
        className="admin-tab"
        style={{
          '--colorPrincipal': colores.colorPrincipal,
          '--colorSecundario': colores.colorSecundario,
          '--color3': colores.color3,
          '--color4': colores.color4,
          '--color5': colores.color5,
          '--color6': colores.color6,
          '--color7': colores.color7,
        }}
      >
        <div className="admin-wrapper">
          <div className={`header ${!miniLateral ? 'compress' : ''}`}>
            <h1 style={{ color: colores.colorPrincipal }}>Suscripción</h1>
          </div>

          {!actualSuscripcion && !isLoading && (
            <p style={{ marginTop: '1rem', color: '#666' }}>
              No hay suscripción activa
            </p>
          )}

          {isLoading && (
            <div style={{ padding: '1rem', textAlign: 'center' }}>
              <p style={{ color: colores.colorPrincipal }}>Cargando suscripción...</p>
            </div>
          )}

          {actualSuscripcion && !isLoading && (
            <>
              <EstadoSuscripcion suscripcion={actualSuscripcion} onUpdate={handleUpdateSuscripcion} />
              <InformacionPago suscripcion={actualSuscripcion} onUpdate={handleUpdateSuscripcion} />
              <HistorialTransacciones suscripcionId={actualSuscripcion._id} />
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div 
      className='suscripciones'
      style={{
        '--colorPrincipal': colores.colorPrincipal,
        '--colorSecundario': colores.colorSecundario,
        '--color3': colores.color3,
        '--color4': colores.color4,
        '--color5': colores.color5,
        '--color6': colores.color6,
        '--color7': colores.color7,
      }}
    >
      <div className={`preheader ${!miniLateral && 'compress'}`}>
        <div className="title">
          <h1 style={{color: colores.colorPrincipal}}>Suscripciones</h1>
        </div>
      </div>
      <div className="table-clientes">
        <div className='table-scrollable'>
          <div className='table-row headers-row'>
            <div className='column name'>
              <p>Empresa</p>
            </div>
            <div 
              className='column estado'
              onClick={() => changeOrderItem('estado')}
            >
              <p>Estado</p>
              {
                (orderBy === 'estado') &&
                <span
                  className={`${ascEstado ? '' : 'desc'}`}
                >
                  <ArrowDownSmallIcon />
                </span>
              }
            </div>
            <div className='column fecha-final'>
              <p>Fecha final</p>
            </div>
            <div 
              className='column created'
              onClick={() => changeOrderItem('creacion')}
            >
              <p>Creado</p>
              {
                (orderBy === 'creacion') &&
                <span
                  className={`${ascCreacion ? '' : 'desc'}`}
                >
                  <ArrowDownSmallIcon />
                </span>
              }
            </div>
          </div>
          {
            !loadingSubscriptions &&
            suscripcionesPaginadas.map((susc) => (
              <SuscripcionRowItem
                key={susc._id}
                suscripcion={susc}
                onUpdate={handleUpdateSuscripcion}
              />
            ))
          }
          {
            !loadingSubscriptions && suscripcionesList.length === 0 &&
            <h3>No hay suscripciones</h3>
          }
        </div>
      </div>
      {
        (suscripcionesList.length > LIMITE_SUSCRIPCIONES) &&
        <div className='paginacion'>
          <div 
            className='pag-btn'
            style={{ 
              backgroundColor: colores.color6, 
              color: colores.colorPrincipal,
              opacity: pagNumber > 1 ? 1 : 0
            }}
            onClick={() => paginacion(-1000)}
          >{'<<'}</div>
          <div 
            className='pag-btn'
            style={{ 
              backgroundColor: colores.color6,
              color: colores.colorPrincipal,
              opacity: pagNumber > 1 ? 1 : 0
            }}
            onClick={() => paginacion(-1)}
          >{'<'}</div>
          <div className='pag-number'>
            Página: {pagNumber}
          </div>
          <div 
            className='pag-btn'
            onClick={() => paginacion(1)}
            style={{ 
              backgroundColor: colores.color6,
              color: colores.colorPrincipal,
              opacity: pagNumber < Math.ceil(suscripcionesList.length / LIMITE_SUSCRIPCIONES) ? 1 : 0
            }}
          >{'>'}</div>
          <div 
            className='pag-btn'
            onClick={() => paginacion(1000000000)}
            style={{ 
              backgroundColor: colores.color6,
              color: colores.colorPrincipal,
              opacity: pagNumber < Math.ceil(suscripcionesList.length / LIMITE_SUSCRIPCIONES) ? 1 : 0
            }}
          >{'>>'}</div>
        </div>
      }
      {
        loadingSubscriptions &&
        <div 
          className='loading-clientes'
        >
          <div className='bg-loading'></div>   
          <p
            style={{ color: colores.colorPrincipal }}
          >Cargando...</p>
        </div>
      }
    </div>
  );
};

export default Suscripciones;
